module.exports = __webpack_public_path__ + "img/social.9c818c7.png";